import axiosHttp from "services/axiosHttp";
import { message } from "antd";
const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

export const createGatepass = createAsyncThunk("createGatepass", async (payload, { rejectWithValue }) => {
	try {
		const response = await axiosHttp.post("gatepass/creategatepass", payload);
		message.success("Gatepass request created successfully");
		return response.data;
	} catch (err) {
		if (!err.response) throw err;
		message.error(err.response?.data?.message || "Failed to create gatepass request");
		return rejectWithValue(err.response.data);
	}
});

const GatepassCreateSlice = createSlice({
	name: "GatepassCreateSlice",
	initialState: {
		isLoading: false,
		data: null,
		error: null,
	},
	reducers: {
		resetGatepassCreate: (state) => {
			state.isLoading = false;
			state.data = null;
			state.error = null;
		},
	},
	extraReducers: (builder) => {
		builder.addCase(createGatepass.pending, (state) => {
			state.isLoading = true;
			state.error = null;
		});
		builder.addCase(createGatepass.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload;
		});
		builder.addCase(createGatepass.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload;
		});
	},
});

export const { resetGatepassCreate } = GatepassCreateSlice.actions;
export default GatepassCreateSlice.reducer;
